export const defaultLogger = console;